import { render, staticRenderFns } from "./XSmsBlastLabel.vue?vue&type=template&id=f3fbd41c&scoped=true"
import script from "./XSmsBlastLabel.vue?vue&type=script&lang=js"
export * from "./XSmsBlastLabel.vue?vue&type=script&lang=js"
import style0 from "./XSmsBlastLabel.vue?vue&type=style&index=0&id=f3fbd41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fbd41c",
  null
  
)

export default component.exports